// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exportshowasset_title
{
    background-color: gray;
    font-size: 13px;
    border-radius: 3px;
    margin-left: 10px;
    margin-right: 15px;
}


.export_assettitle
{
  width: 100%;
  height: 20px;
}

.export_assetdatas
{
  width: 100%;
  height: calc(100% - 70px);
}

.exportformatnonselected
{
    width: calc(100% - 20px);
    margin-left: 10px;
    background-color: transparent;
    text-align: left;
    margin-top: 5px;
}

.exportformatselected
{
    width: calc(100% - 20px);
    margin-left: 10px;
    background-color: #000080;
    text-align: left;
    border-radius: 4px;
    margin-top: 5px;
}

.exportformatline1
{
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center; /* Alignement vertical */    
    font-size: 13px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.exportformatliste
{
    width: 100%;
    height: 100%;
    
    overflow:auto;
}
.exportformatliste-header::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
  .exportformatliste-header::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

  .exportformatliste-header::-webkit-scrollbar{
    width:12px;
}



.exportformatliste::-webkit-scrollbar-track {
    background: #101010; /* color of the tracking area */
  }
  
  .exportformatliste::-webkit-scrollbar-thumb {
    background-color: #151515; /* color of the scroll thumb */
    border-radius: 20px; /* roundness of the scroll thumb */
    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
  }

  .exportformatliste::-webkit-scrollbar{
    width:12px;
}





.paramsexport_full
{
  width: 100%;
  height: calc(100% - 40px);
  
  
}

.paramsexport_title
{
  width: 96%;
  height: 20px;
  font-size: 12px;
  text-align: center;
  color: white;
  background-color:#000090;
  border-radius: 2px;
  border-style: solid;
  border-color: white;
  border-width: 1px;
  margin-left: 1%;
  margin-right: 1%;
}

.paramsexport_body
{
  text-align: left;
  width: 100%;
  height: calc(100% - 68px);
  background-color: transparent;
  overflow-x: hidden;
  overflow-y: auto;
}


.paramsexport_body-header::-webkit-scrollbar-track {
  background: #101010; /* color of the tracking area */
}

.paramsexport_body-header::-webkit-scrollbar-thumb {
  background-color: #151515; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
}

.paramsexport_body-header::-webkit-scrollbar{
  width:12px;
}



.paramsexport_body::-webkit-scrollbar-track {
  background: #101010; /* color of the tracking area */
}

.paramsexport_body::-webkit-scrollbar-thumb {
  background-color: #151515; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
}

.paramsexport_body::-webkit-scrollbar{
  width:12px;
}



.paramexport_buttons
{
  margin-left: 2%;
  margin-right: 2%;
  width: 96%;
  height: 40px;
  text-align: right;
  padding-top: 4px;
  background-color: #101010;
  border-radius: 6px;
  border-style: solid;
  border-color: #303030;
  border-width: 1px;
}


.preview_div_ttml
{
  text-align: left;
  padding-left: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.preview_div_ttml pre code {
    color: #f8f8f2;
}

.preview_div_ttml .hljs-tag,
.preview_div_ttml .hljs-name {
    color: #ff79c6;
}

.preview_div_ttml .hljs-attr {
    color: #50fa7b;
}

.preview_div_ttml .hljs-string {
    color: #f1fa8c;
}



.preview_div_srt
{
  text-align: left;
  padding-left: 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.preview_div_srt::-webkit-scrollbar-track {
  background: #101010; /* color of the tracking area */
}

.preview_div_srt::-webkit-scrollbar-thumb {
  background-color: #151515; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */
}

.preview_div_srt::-webkit-scrollbar{
  width:12px;
}


`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/exportscomponents/exportsstyles.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;IAEI,wBAAwB;IACxB,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,wBAAwB;IACxB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,+BAA+B;IAC/B,mBAAmB,EAAE,wBAAwB;IAC7C,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;;IAEZ,aAAa;AACjB;AACA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA;IACE,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;EAEA;IACE,UAAU;AACd;;;;AAIA;IACI,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA;IACE,yBAAyB,EAAE,8BAA8B;IACzD,mBAAmB,EAAE,kCAAkC;IACvD,2CAA2C,EAAE,wCAAwC;EACvF;;EAEA;IACE,UAAU;AACd;;;;;;AAMA;;EAEE,WAAW;EACX,yBAAyB;;;AAG3B;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,wCAAwC;AACvF;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,wCAAwC;AACvF;;AAEA;EACE,UAAU;AACZ;;;;AAIA;;EAEE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;;AAIA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,mBAAmB,EAAE,kCAAkC;EACvD,2CAA2C,EAAE,wCAAwC;AACvF;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".exportshowasset_title\n{\n    background-color: gray;\n    font-size: 13px;\n    border-radius: 3px;\n    margin-left: 10px;\n    margin-right: 15px;\n}\n\n\n.export_assettitle\n{\n  width: 100%;\n  height: 20px;\n}\n\n.export_assetdatas\n{\n  width: 100%;\n  height: calc(100% - 70px);\n}\n\n.exportformatnonselected\n{\n    width: calc(100% - 20px);\n    margin-left: 10px;\n    background-color: transparent;\n    text-align: left;\n    margin-top: 5px;\n}\n\n.exportformatselected\n{\n    width: calc(100% - 20px);\n    margin-left: 10px;\n    background-color: #000080;\n    text-align: left;\n    border-radius: 4px;\n    margin-top: 5px;\n}\n\n.exportformatline1\n{\n    display: grid;\n    grid-template-columns: auto 1fr;\n    align-items: center; /* Alignement vertical */    \n    font-size: 13px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.exportformatliste\n{\n    width: 100%;\n    height: 100%;\n    \n    overflow:auto;\n}\n.exportformatliste-header::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n  .exportformatliste-header::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n  .exportformatliste-header::-webkit-scrollbar{\n    width:12px;\n}\n\n\n\n.exportformatliste::-webkit-scrollbar-track {\n    background: #101010; /* color of the tracking area */\n  }\n  \n  .exportformatliste::-webkit-scrollbar-thumb {\n    background-color: #151515; /* color of the scroll thumb */\n    border-radius: 20px; /* roundness of the scroll thumb */\n    border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n  }\n\n  .exportformatliste::-webkit-scrollbar{\n    width:12px;\n}\n\n\n\n\n\n.paramsexport_full\n{\n  width: 100%;\n  height: calc(100% - 40px);\n  \n  \n}\n\n.paramsexport_title\n{\n  width: 96%;\n  height: 20px;\n  font-size: 12px;\n  text-align: center;\n  color: white;\n  background-color:#000090;\n  border-radius: 2px;\n  border-style: solid;\n  border-color: white;\n  border-width: 1px;\n  margin-left: 1%;\n  margin-right: 1%;\n}\n\n.paramsexport_body\n{\n  text-align: left;\n  width: 100%;\n  height: calc(100% - 68px);\n  background-color: transparent;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n\n.paramsexport_body-header::-webkit-scrollbar-track {\n  background: #101010; /* color of the tracking area */\n}\n\n.paramsexport_body-header::-webkit-scrollbar-thumb {\n  background-color: #151515; /* color of the scroll thumb */\n  border-radius: 20px; /* roundness of the scroll thumb */\n  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n}\n\n.paramsexport_body-header::-webkit-scrollbar{\n  width:12px;\n}\n\n\n\n.paramsexport_body::-webkit-scrollbar-track {\n  background: #101010; /* color of the tracking area */\n}\n\n.paramsexport_body::-webkit-scrollbar-thumb {\n  background-color: #151515; /* color of the scroll thumb */\n  border-radius: 20px; /* roundness of the scroll thumb */\n  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n}\n\n.paramsexport_body::-webkit-scrollbar{\n  width:12px;\n}\n\n\n\n.paramexport_buttons\n{\n  margin-left: 2%;\n  margin-right: 2%;\n  width: 96%;\n  height: 40px;\n  text-align: right;\n  padding-top: 4px;\n  background-color: #101010;\n  border-radius: 6px;\n  border-style: solid;\n  border-color: #303030;\n  border-width: 1px;\n}\n\n\n.preview_div_ttml\n{\n  text-align: left;\n  padding-left: 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.preview_div_ttml pre code {\n    color: #f8f8f2;\n}\n\n.preview_div_ttml .hljs-tag,\n.preview_div_ttml .hljs-name {\n    color: #ff79c6;\n}\n\n.preview_div_ttml .hljs-attr {\n    color: #50fa7b;\n}\n\n.preview_div_ttml .hljs-string {\n    color: #f1fa8c;\n}\n\n\n\n.preview_div_srt\n{\n  text-align: left;\n  padding-left: 20px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.preview_div_srt::-webkit-scrollbar-track {\n  background: #101010; /* color of the tracking area */\n}\n\n.preview_div_srt::-webkit-scrollbar-thumb {\n  background-color: #151515; /* color of the scroll thumb */\n  border-radius: 20px; /* roundness of the scroll thumb */\n  border: 1px solid var(--default-icon-color); /* creates padding around scroll thumb */\n}\n\n.preview_div_srt::-webkit-scrollbar{\n  width:12px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
